"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsercryptApi = exports.UsercryptApiFactory = exports.UsercryptApiFp = exports.UsercryptApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * UsercryptApi - axios parameter creator
 * @export
 */
const UsercryptApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Add a new checkin entries |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary add checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
         * @param {UsercryptAddCheckinEntriesRequest} [usercryptAddCheckinEntriesRequest] The checkin data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptAddCheckinEntries: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, acceptLanguage, checkinTypeKey, usercryptAddCheckinEntriesRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptAddCheckinEntries', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptAddCheckinEntries', 'recipientId', recipientId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/checkin/entries`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (checkinTypeKey !== undefined) {
                localVarQueryParameter['checkin_type_key'] = checkinTypeKey;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/checkin/entries`,
                sdkMethod: 'usercryptAddCheckinEntries',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(usercryptAddCheckinEntriesRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Add a new checkin entry |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary add checkin entry
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {UsercryptAddCheckinEntryRequest} [usercryptAddCheckinEntryRequest] The checkin data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptAddCheckinEntry: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, checkinTypeKey, acceptLanguage, usercryptAddCheckinEntryRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptAddCheckinEntry', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptAddCheckinEntry', 'recipientId', recipientId);
            // verify required parameter 'checkinTypeKey' is not null or undefined
            (0, common_1.assertParamExists)('usercryptAddCheckinEntry', 'checkinTypeKey', checkinTypeKey);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'checkin_type_key'}}`, encodeURIComponent(String(checkinTypeKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries`,
                sdkMethod: 'usercryptAddCheckinEntry',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(usercryptAddCheckinEntryRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Add checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary Adds a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {UsercryptCheckinReminderRequest} [usercryptCheckinReminderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptAddSettingReminderForType: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, checkinTypeKey, userId, usercryptCheckinReminderRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptAddSettingReminderForType', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptAddSettingReminderForType', 'recipientId', recipientId);
            // verify required parameter 'checkinTypeKey' is not null or undefined
            (0, common_1.assertParamExists)('usercryptAddSettingReminderForType', 'checkinTypeKey', checkinTypeKey);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptAddSettingReminderForType', 'userId', userId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'checkin_type_key'}}`, encodeURIComponent(String(checkinTypeKey)))
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`,
                sdkMethod: 'usercryptAddSettingReminderForType',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(usercryptCheckinReminderRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
         * @summary Post or create a condition attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptCreateConditionRequest} usercryptCreateConditionRequest Patch Circle request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptCreateCondition: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, usercryptCreateConditionRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptCreateCondition', 'recipientId', recipientId);
            // verify required parameter 'usercryptCreateConditionRequest' is not null or undefined
            (0, common_1.assertParamExists)('usercryptCreateCondition', 'usercryptCreateConditionRequest', usercryptCreateConditionRequest);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/conditions`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/conditions`,
                sdkMethod: 'usercryptCreateCondition',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(usercryptCreateConditionRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
         * @summary Post or create a conditions attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptCreateConditionsRequest} usercryptCreateConditionsRequest Create Conditions Request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptCreateConditionsV2: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, usercryptCreateConditionsRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptCreateConditionsV2', 'recipientId', recipientId);
            // verify required parameter 'usercryptCreateConditionsRequest' is not null or undefined
            (0, common_1.assertParamExists)('usercryptCreateConditionsV2', 'usercryptCreateConditionsRequest', usercryptCreateConditionsRequest);
            const localVarPath = `/v2/usercrypt/recipients/{recipient_id}/conditions`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/usercrypt/recipients/{recipient_id}/conditions`,
                sdkMethod: 'usercryptCreateConditionsV2',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(usercryptCreateConditionsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Soft delete all recipient checkin data |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary delete recipient data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteAllRecipientData: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteAllRecipientData', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteAllRecipientData', 'recipientId', recipientId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}`,
                sdkMethod: 'usercryptDeleteAllRecipientData',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Delete an individual checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary Delete checkin entry
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {number} checkinEntryId Checkin Entry Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteCheckinEntryById: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, checkinTypeKey, checkinEntryId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteCheckinEntryById', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteCheckinEntryById', 'recipientId', recipientId);
            // verify required parameter 'checkinTypeKey' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteCheckinEntryById', 'checkinTypeKey', checkinTypeKey);
            // verify required parameter 'checkinEntryId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteCheckinEntryById', 'checkinEntryId', checkinEntryId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries/{checkin_entry_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'checkin_type_key'}}`, encodeURIComponent(String(checkinTypeKey)))
                .replace(`{${'checkin_entry_id'}}`, encodeURIComponent(String(checkinEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries/{checkin_entry_id}`,
                sdkMethod: 'usercryptDeleteCheckinEntryById',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | d |
         * @summary Delete a condition attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} conditionId Condition ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteCondition: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, conditionId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteCondition', 'recipientId', recipientId);
            // verify required parameter 'conditionId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteCondition', 'conditionId', conditionId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/conditions/{condition_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'condition_id'}}`, encodeURIComponent(String(conditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/conditions/{condition_id}`,
                sdkMethod: 'usercryptDeleteCondition',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | d |
         * @summary Delete conditions attached to a recipient. If no condition IDs are provided, all conditions are deleted.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<number>} id Condition IDs
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteConditions: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, id, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteConditions', 'recipientId', recipientId);
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteConditions', 'id', id);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/conditions`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/conditions`,
                sdkMethod: 'usercryptDeleteConditions',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary Deletes a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteReminderForType: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, checkinTypeKey, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteReminderForType', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteReminderForType', 'recipientId', recipientId);
            // verify required parameter 'checkinTypeKey' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteReminderForType', 'checkinTypeKey', checkinTypeKey);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteReminderForType', 'userId', userId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'checkin_type_key'}}`, encodeURIComponent(String(checkinTypeKey)))
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`,
                sdkMethod: 'usercryptDeleteReminderForType',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Deletes a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary Deletes a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteSettingReminder: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteSettingReminder', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteSettingReminder', 'recipientId', recipientId);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptDeleteSettingReminder', 'userId', userId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders`,
                sdkMethod: 'usercryptDeleteSettingReminder',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Expunge all recipient checkin data permanently. |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|e|
         * @summary expunge recipient data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptExpungeAllRecipientData: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptExpungeAllRecipientData', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptExpungeAllRecipientData', 'recipientId', recipientId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/usercrypt/expunge`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/usercrypt/expunge`,
                sdkMethod: 'usercryptExpungeAllRecipientData',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
         * @summary Gets all conditions for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetAllConditions: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetAllConditions', 'recipientId', recipientId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/conditions`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/conditions`,
                sdkMethod: 'usercryptGetAllConditions',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get the number of entries given for a recipient today and what the max allowed is |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary Get Recipient Daily Quota
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinDailyQuota: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinDailyQuota', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinDailyQuota', 'recipientId', recipientId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/checkin/entries/quota`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/checkin/entries/quota`,
                sdkMethod: 'usercryptGetCheckinDailyQuota',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get checkin entries for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary get checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [start] Start date of search
         * @param {string} [end] End date of search
         * @param {number} [offset] The offset of results to return
         * @param {number} [limit] The limit of number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinEntriesByType: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, checkinTypeKey, acceptLanguage, start, end, offset, limit, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinEntriesByType', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinEntriesByType', 'recipientId', recipientId);
            // verify required parameter 'checkinTypeKey' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinEntriesByType', 'checkinTypeKey', checkinTypeKey);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'checkin_type_key'}}`, encodeURIComponent(String(checkinTypeKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (start !== undefined) {
                localVarQueryParameter['start'] =
                    start instanceof Date
                        ? start.toISOString()
                        : start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] =
                    end instanceof Date
                        ? end.toISOString()
                        : end;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries`,
                sdkMethod: 'usercryptGetCheckinEntriesByType',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a single checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary Get Checkin Entry By Id
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {number} checkinEntryId Checkin Entry Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinEntryById: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, checkinTypeKey, checkinEntryId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinEntryById', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinEntryById', 'recipientId', recipientId);
            // verify required parameter 'checkinTypeKey' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinEntryById', 'checkinTypeKey', checkinTypeKey);
            // verify required parameter 'checkinEntryId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinEntryById', 'checkinEntryId', checkinEntryId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries/{checkin_entry_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'checkin_type_key'}}`, encodeURIComponent(String(checkinTypeKey)))
                .replace(`{${'checkin_entry_id'}}`, encodeURIComponent(String(checkinEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries/{checkin_entry_id}`,
                sdkMethod: 'usercryptGetCheckinEntryById',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Gets the latest entries of each checkin type |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary get latest checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {boolean} [withEntry] Only with atleast one checkin entry
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
         * @param {'all' | 'bookmarked' | 'notBookmarked'} [bookmarks] Bookmark filter&lt;br /&gt; * **all** - This is the default, return all summaries regardless if they\&#39;re bookmarked or not&lt;br /&gt; * **bookmarked** - Only return summaries that are bookmarked&lt;br /&gt; * **notBookmarked** - Only return summaries that are NOT bookmarked. In other words, exclude bookmarks &lt;br /&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinLatestEntries: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, withEntry, acceptLanguage, checkinTypeKey, bookmarks, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinLatestEntries', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinLatestEntries', 'recipientId', recipientId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/checkin/summary`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (withEntry !== undefined) {
                localVarQueryParameter['withEntry'] = withEntry;
            }
            if (checkinTypeKey !== undefined) {
                localVarQueryParameter['checkin_type_key'] = checkinTypeKey;
            }
            if (bookmarks !== undefined) {
                localVarQueryParameter['bookmarks'] = bookmarks;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/checkin/summary`,
                sdkMethod: 'usercryptGetCheckinLatestEntries',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns all recipient checkin entries |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary all recipient checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinRecipientEntries: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, acceptLanguage, checkinTypeKey, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinRecipientEntries', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetCheckinRecipientEntries', 'recipientId', recipientId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/checkin/entries`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (checkinTypeKey !== undefined) {
                localVarQueryParameter['checkin_type_key'] = checkinTypeKey;
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/checkin/entries`,
                sdkMethod: 'usercryptGetCheckinRecipientEntries',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * returns checkin type meta data |Feature|Dataclass|Permission| |-------|---------|----------|
         * @summary Checkin types
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinTypes: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ acceptLanguage }, options = {}) {
            const localVarPath = `/v1/usercrypt/checkin/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/checkin/types`,
                sdkMethod: 'usercryptGetCheckinTypes',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
         * @summary Gets a condition attached to a recipient by ID
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} conditionId Condition ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetConditionById: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, conditionId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetConditionById', 'recipientId', recipientId);
            // verify required parameter 'conditionId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetConditionById', 'conditionId', conditionId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/conditions/{condition_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'condition_id'}}`, encodeURIComponent(String(conditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/conditions/{condition_id}`,
                sdkMethod: 'usercryptGetConditionById',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all recipient reminders |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary get recipient reminders
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetSettingAllRecipientReminders: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetSettingAllRecipientReminders', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetSettingAllRecipientReminders', 'recipientId', recipientId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/settings/reminders`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/settings/reminders`,
                sdkMethod: 'usercryptGetSettingAllRecipientReminders',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get reminder of checkin type if it exists |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary Get user checkin reminder for this checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetSettingReminderByType: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, checkinTypeKey, userId, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetSettingReminderByType', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetSettingReminderByType', 'recipientId', recipientId);
            // verify required parameter 'checkinTypeKey' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetSettingReminderByType', 'checkinTypeKey', checkinTypeKey);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetSettingReminderByType', 'userId', userId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'checkin_type_key'}}`, encodeURIComponent(String(checkinTypeKey)))
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`,
                sdkMethod: 'usercryptGetSettingReminderByType',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
         * @summary Gets statis information attached to a recipient by ID
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetStaticData: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptGetStaticData', 'recipientId', recipientId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/static`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/static`,
                sdkMethod: 'usercryptGetStaticData',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * returns supported conditions in backend config |Feature|Dataclass|Permission| |-------|---------|----------|
         * @summary Get Supported Conditions
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetSupportedConditions: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ acceptLanguage }, options = {}) {
            const localVarPath = `/v1/usercrypt/conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/conditions`,
                sdkMethod: 'usercryptGetSupportedConditions',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | u |
         * @summary Patch or update a condition attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} conditionId Condition ID
         * @param {UsercryptPatchConditionRequest} usercryptPatchConditionRequest Patch Condition request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptPatchCondition: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, conditionId, usercryptPatchConditionRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptPatchCondition', 'recipientId', recipientId);
            // verify required parameter 'conditionId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptPatchCondition', 'conditionId', conditionId);
            // verify required parameter 'usercryptPatchConditionRequest' is not null or undefined
            (0, common_1.assertParamExists)('usercryptPatchCondition', 'usercryptPatchConditionRequest', usercryptPatchConditionRequest);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/conditions/{condition_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'condition_id'}}`, encodeURIComponent(String(conditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/conditions/{condition_id}`,
                sdkMethod: 'usercryptPatchCondition',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(usercryptPatchConditionRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Bookmarks a checkin type |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary bookmark a checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptPutSettingsBookmarkType: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, checkinTypeKey, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptPutSettingsBookmarkType', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptPutSettingsBookmarkType', 'recipientId', recipientId);
            // verify required parameter 'checkinTypeKey' is not null or undefined
            (0, common_1.assertParamExists)('usercryptPutSettingsBookmarkType', 'checkinTypeKey', checkinTypeKey);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/settings/bookmarks/{checkin_type_key}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'checkin_type_key'}}`, encodeURIComponent(String(checkinTypeKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/settings/bookmarks/{checkin_type_key}`,
                sdkMethod: 'usercryptPutSettingsBookmarkType',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Removes a checkin type key bookmark |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary unbookmark a checkin type key
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptRemoveBookmarkType: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, checkinTypeKey, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptRemoveBookmarkType', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptRemoveBookmarkType', 'recipientId', recipientId);
            // verify required parameter 'checkinTypeKey' is not null or undefined
            (0, common_1.assertParamExists)('usercryptRemoveBookmarkType', 'checkinTypeKey', checkinTypeKey);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/settings/bookmarks/{checkin_type_key}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'checkin_type_key'}}`, encodeURIComponent(String(checkinTypeKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/settings/bookmarks/{checkin_type_key}`,
                sdkMethod: 'usercryptRemoveBookmarkType',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update an existing checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|u|
         * @summary Update checkin entry
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {number} checkinEntryId Checkin Entry Id
         * @param {UsercryptUpdateCheckinEntryRequest} [usercryptUpdateCheckinEntryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptUpdateCheckinEntryById: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, checkinTypeKey, checkinEntryId, usercryptUpdateCheckinEntryRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptUpdateCheckinEntryById', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptUpdateCheckinEntryById', 'recipientId', recipientId);
            // verify required parameter 'checkinTypeKey' is not null or undefined
            (0, common_1.assertParamExists)('usercryptUpdateCheckinEntryById', 'checkinTypeKey', checkinTypeKey);
            // verify required parameter 'checkinEntryId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptUpdateCheckinEntryById', 'checkinEntryId', checkinEntryId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries/{checkin_entry_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'checkin_type_key'}}`, encodeURIComponent(String(checkinTypeKey)))
                .replace(`{${'checkin_entry_id'}}`, encodeURIComponent(String(checkinEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries/{checkin_entry_id}`,
                sdkMethod: 'usercryptUpdateCheckinEntryById',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(usercryptUpdateCheckinEntryRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Update a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|u|
         * @summary Updates a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {UsercryptCheckinReminderRequest} [usercryptCheckinReminderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptUpdateSettingReminderForType: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, checkinTypeKey, userId, usercryptCheckinReminderRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('usercryptUpdateSettingReminderForType', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptUpdateSettingReminderForType', 'recipientId', recipientId);
            // verify required parameter 'checkinTypeKey' is not null or undefined
            (0, common_1.assertParamExists)('usercryptUpdateSettingReminderForType', 'checkinTypeKey', checkinTypeKey);
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptUpdateSettingReminderForType', 'userId', userId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'checkin_type_key'}}`, encodeURIComponent(String(checkinTypeKey)))
                .replace(`{${'user_id'}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`,
                sdkMethod: 'usercryptUpdateSettingReminderForType',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(usercryptCheckinReminderRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
         * @summary Insert or Update a static data attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptUpsertStaticDataRequest} usercryptUpsertStaticDataRequest Patch Condition request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptUpsertStaticData: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, usercryptUpsertStaticDataRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('usercryptUpsertStaticData', 'recipientId', recipientId);
            // verify required parameter 'usercryptUpsertStaticDataRequest' is not null or undefined
            (0, common_1.assertParamExists)('usercryptUpsertStaticData', 'usercryptUpsertStaticDataRequest', usercryptUpsertStaticDataRequest);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/static`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/static`,
                sdkMethod: 'usercryptUpsertStaticData',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(usercryptUpsertStaticDataRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Copies all the data - condition, checkin_entry, static_data, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | usercrypt | usercrypt | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {RbcRecipientCopyRequest} [rbcRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, rbcRecipientCopyRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyDataToNewRecipient', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyDataToNewRecipient', 'recipientId', recipientId);
            const localVarPath = `/v1/recommendations/recipients/{recipient_id}/copy`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/recommendations/recipients/{recipient_id}/copy`,
                sdkMethod: 'v1CopyDataToNewRecipient',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rbcRecipientCopyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Copies all the data - condition, checkin_entry, static_data, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | usercrypt | usercrypt | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptRecipientCopyRequest} [usercryptRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient_1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ circleAuthorizationToken, recipientId, usercryptRecipientCopyRequest, }, options = {}) {
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyDataToNewRecipient_1', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1CopyDataToNewRecipient_1', 'recipientId', recipientId);
            const localVarPath = `/v1/usercrypt/recipients/{recipient_id}/copy`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/usercrypt/recipients/{recipient_id}/copy`,
                sdkMethod: 'v1CopyDataToNewRecipient_1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(usercryptRecipientCopyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UsercryptApiAxiosParamCreator = UsercryptApiAxiosParamCreator;
/**
 * UsercryptApi - functional programming interface
 * @export
 */
const UsercryptApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UsercryptApiAxiosParamCreator)(configuration);
    return {
        /**
         * Add a new checkin entries |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary add checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
         * @param {UsercryptAddCheckinEntriesRequest} [usercryptAddCheckinEntriesRequest] The checkin data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptAddCheckinEntries(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptAddCheckinEntries(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Add a new checkin entry |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary add checkin entry
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {UsercryptAddCheckinEntryRequest} [usercryptAddCheckinEntryRequest] The checkin data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptAddCheckinEntry(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptAddCheckinEntry(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Add checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary Adds a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {UsercryptCheckinReminderRequest} [usercryptCheckinReminderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptAddSettingReminderForType(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptAddSettingReminderForType(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
         * @summary Post or create a condition attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptCreateConditionRequest} usercryptCreateConditionRequest Patch Circle request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptCreateCondition(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptCreateCondition(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
         * @summary Post or create a conditions attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptCreateConditionsRequest} usercryptCreateConditionsRequest Create Conditions Request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptCreateConditionsV2(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptCreateConditionsV2(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Soft delete all recipient checkin data |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary delete recipient data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteAllRecipientData(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptDeleteAllRecipientData(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Delete an individual checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary Delete checkin entry
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {number} checkinEntryId Checkin Entry Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteCheckinEntryById(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptDeleteCheckinEntryById(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | d |
         * @summary Delete a condition attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} conditionId Condition ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteCondition(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptDeleteCondition(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | d |
         * @summary Delete conditions attached to a recipient. If no condition IDs are provided, all conditions are deleted.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<number>} id Condition IDs
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteConditions(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptDeleteConditions(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary Deletes a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteReminderForType(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptDeleteReminderForType(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Deletes a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary Deletes a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteSettingReminder(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptDeleteSettingReminder(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Expunge all recipient checkin data permanently. |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|e|
         * @summary expunge recipient data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptExpungeAllRecipientData(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptExpungeAllRecipientData(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
         * @summary Gets all conditions for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetAllConditions(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetAllConditions(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get the number of entries given for a recipient today and what the max allowed is |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary Get Recipient Daily Quota
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinDailyQuota(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetCheckinDailyQuota(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * get checkin entries for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary get checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [start] Start date of search
         * @param {string} [end] End date of search
         * @param {number} [offset] The offset of results to return
         * @param {number} [limit] The limit of number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinEntriesByType(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetCheckinEntriesByType(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get a single checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary Get Checkin Entry By Id
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {number} checkinEntryId Checkin Entry Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinEntryById(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetCheckinEntryById(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Gets the latest entries of each checkin type |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary get latest checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {boolean} [withEntry] Only with atleast one checkin entry
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
         * @param {'all' | 'bookmarked' | 'notBookmarked'} [bookmarks] Bookmark filter&lt;br /&gt; * **all** - This is the default, return all summaries regardless if they\&#39;re bookmarked or not&lt;br /&gt; * **bookmarked** - Only return summaries that are bookmarked&lt;br /&gt; * **notBookmarked** - Only return summaries that are NOT bookmarked. In other words, exclude bookmarks &lt;br /&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinLatestEntries(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetCheckinLatestEntries(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns all recipient checkin entries |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary all recipient checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinRecipientEntries(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetCheckinRecipientEntries(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * returns checkin type meta data |Feature|Dataclass|Permission| |-------|---------|----------|
         * @summary Checkin types
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinTypes(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetCheckinTypes(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
         * @summary Gets a condition attached to a recipient by ID
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} conditionId Condition ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetConditionById(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetConditionById(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get all recipient reminders |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary get recipient reminders
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetSettingAllRecipientReminders(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetSettingAllRecipientReminders(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get reminder of checkin type if it exists |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary Get user checkin reminder for this checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetSettingReminderByType(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetSettingReminderByType(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
         * @summary Gets statis information attached to a recipient by ID
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetStaticData(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetStaticData(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * returns supported conditions in backend config |Feature|Dataclass|Permission| |-------|---------|----------|
         * @summary Get Supported Conditions
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetSupportedConditions(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptGetSupportedConditions(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | u |
         * @summary Patch or update a condition attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} conditionId Condition ID
         * @param {UsercryptPatchConditionRequest} usercryptPatchConditionRequest Patch Condition request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptPatchCondition(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptPatchCondition(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Bookmarks a checkin type |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary bookmark a checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptPutSettingsBookmarkType(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptPutSettingsBookmarkType(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Removes a checkin type key bookmark |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary unbookmark a checkin type key
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptRemoveBookmarkType(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptRemoveBookmarkType(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update an existing checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|u|
         * @summary Update checkin entry
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {number} checkinEntryId Checkin Entry Id
         * @param {UsercryptUpdateCheckinEntryRequest} [usercryptUpdateCheckinEntryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptUpdateCheckinEntryById(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptUpdateCheckinEntryById(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Update a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|u|
         * @summary Updates a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {UsercryptCheckinReminderRequest} [usercryptCheckinReminderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptUpdateSettingReminderForType(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptUpdateSettingReminderForType(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
         * @summary Insert or Update a static data attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptUpsertStaticDataRequest} usercryptUpsertStaticDataRequest Patch Condition request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptUpsertStaticData(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.usercryptUpsertStaticData(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Copies all the data - condition, checkin_entry, static_data, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | usercrypt | usercrypt | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {RbcRecipientCopyRequest} [rbcRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1CopyDataToNewRecipient(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Copies all the data - condition, checkin_entry, static_data, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | usercrypt | usercrypt | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptRecipientCopyRequest} [usercryptRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient_1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1CopyDataToNewRecipient_1(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.UsercryptApiFp = UsercryptApiFp;
/**
 * UsercryptApi - factory interface
 * @export
 */
const UsercryptApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UsercryptApiFp)(configuration);
    return {
        /**
         * Add a new checkin entries |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary add checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
         * @param {UsercryptAddCheckinEntriesRequest} [usercryptAddCheckinEntriesRequest] The checkin data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptAddCheckinEntries(params, options) {
            return localVarFp
                .usercryptAddCheckinEntries(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Add a new checkin entry |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary add checkin entry
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {UsercryptAddCheckinEntryRequest} [usercryptAddCheckinEntryRequest] The checkin data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptAddCheckinEntry(params, options) {
            return localVarFp
                .usercryptAddCheckinEntry(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Add checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary Adds a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {UsercryptCheckinReminderRequest} [usercryptCheckinReminderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptAddSettingReminderForType(params, options) {
            return localVarFp
                .usercryptAddSettingReminderForType(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
         * @summary Post or create a condition attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptCreateConditionRequest} usercryptCreateConditionRequest Patch Circle request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptCreateCondition(params, options) {
            return localVarFp
                .usercryptCreateCondition(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
         * @summary Post or create a conditions attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptCreateConditionsRequest} usercryptCreateConditionsRequest Create Conditions Request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptCreateConditionsV2(params, options) {
            return localVarFp
                .usercryptCreateConditionsV2(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Soft delete all recipient checkin data |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary delete recipient data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteAllRecipientData(params, options) {
            return localVarFp
                .usercryptDeleteAllRecipientData(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Delete an individual checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary Delete checkin entry
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {number} checkinEntryId Checkin Entry Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteCheckinEntryById(params, options) {
            return localVarFp
                .usercryptDeleteCheckinEntryById(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | d |
         * @summary Delete a condition attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} conditionId Condition ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteCondition(params, options) {
            return localVarFp
                .usercryptDeleteCondition(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | d |
         * @summary Delete conditions attached to a recipient. If no condition IDs are provided, all conditions are deleted.
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<number>} id Condition IDs
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteConditions(params, options) {
            return localVarFp
                .usercryptDeleteConditions(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Deletes a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary Deletes a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteReminderForType(params, options) {
            return localVarFp
                .usercryptDeleteReminderForType(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Deletes a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary Deletes a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptDeleteSettingReminder(params, options) {
            return localVarFp
                .usercryptDeleteSettingReminder(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Expunge all recipient checkin data permanently. |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|e|
         * @summary expunge recipient data
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptExpungeAllRecipientData(params, options) {
            return localVarFp
                .usercryptExpungeAllRecipientData(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
         * @summary Gets all conditions for the recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetAllConditions(params, options) {
            return localVarFp
                .usercryptGetAllConditions(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get the number of entries given for a recipient today and what the max allowed is |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary Get Recipient Daily Quota
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinDailyQuota(params, options) {
            return localVarFp
                .usercryptGetCheckinDailyQuota(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * get checkin entries for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary get checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [start] Start date of search
         * @param {string} [end] End date of search
         * @param {number} [offset] The offset of results to return
         * @param {number} [limit] The limit of number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinEntriesByType(params, options) {
            return localVarFp
                .usercryptGetCheckinEntriesByType(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get a single checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary Get Checkin Entry By Id
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {number} checkinEntryId Checkin Entry Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinEntryById(params, options) {
            return localVarFp
                .usercryptGetCheckinEntryById(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Gets the latest entries of each checkin type |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary get latest checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {boolean} [withEntry] Only with atleast one checkin entry
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
         * @param {'all' | 'bookmarked' | 'notBookmarked'} [bookmarks] Bookmark filter&lt;br /&gt; * **all** - This is the default, return all summaries regardless if they\&#39;re bookmarked or not&lt;br /&gt; * **bookmarked** - Only return summaries that are bookmarked&lt;br /&gt; * **notBookmarked** - Only return summaries that are NOT bookmarked. In other words, exclude bookmarks &lt;br /&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinLatestEntries(params, options) {
            return localVarFp
                .usercryptGetCheckinLatestEntries(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns all recipient checkin entries |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary all recipient checkin entries
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinRecipientEntries(params, options) {
            return localVarFp
                .usercryptGetCheckinRecipientEntries(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * returns checkin type meta data |Feature|Dataclass|Permission| |-------|---------|----------|
         * @summary Checkin types
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetCheckinTypes(params, options) {
            return localVarFp
                .usercryptGetCheckinTypes(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
         * @summary Gets a condition attached to a recipient by ID
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} conditionId Condition ID
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetConditionById(params, options) {
            return localVarFp
                .usercryptGetConditionById(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get all recipient reminders |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary get recipient reminders
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetSettingAllRecipientReminders(params, options) {
            return localVarFp
                .usercryptGetSettingAllRecipientReminders(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get reminder of checkin type if it exists |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
         * @summary Get user checkin reminder for this checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetSettingReminderByType(params, options) {
            return localVarFp
                .usercryptGetSettingReminderByType(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
         * @summary Gets statis information attached to a recipient by ID
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetStaticData(params, options) {
            return localVarFp
                .usercryptGetStaticData(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * returns supported conditions in backend config |Feature|Dataclass|Permission| |-------|---------|----------|
         * @summary Get Supported Conditions
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptGetSupportedConditions(params, options) {
            return localVarFp
                .usercryptGetSupportedConditions(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | u |
         * @summary Patch or update a condition attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} conditionId Condition ID
         * @param {UsercryptPatchConditionRequest} usercryptPatchConditionRequest Patch Condition request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptPatchCondition(params, options) {
            return localVarFp
                .usercryptPatchCondition(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Bookmarks a checkin type |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
         * @summary bookmark a checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptPutSettingsBookmarkType(params, options) {
            return localVarFp
                .usercryptPutSettingsBookmarkType(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Removes a checkin type key bookmark |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
         * @summary unbookmark a checkin type key
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptRemoveBookmarkType(params, options) {
            return localVarFp
                .usercryptRemoveBookmarkType(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update an existing checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|u|
         * @summary Update checkin entry
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {number} checkinEntryId Checkin Entry Id
         * @param {UsercryptUpdateCheckinEntryRequest} [usercryptUpdateCheckinEntryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptUpdateCheckinEntryById(params, options) {
            return localVarFp
                .usercryptUpdateCheckinEntryById(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Update a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|u|
         * @summary Updates a reminder for the checkin type
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} checkinTypeKey Checkin Type Key
         * @param {string} userId User ID, Use \&quot;current\&quot;
         * @param {UsercryptCheckinReminderRequest} [usercryptCheckinReminderRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptUpdateSettingReminderForType(params, options) {
            return localVarFp
                .usercryptUpdateSettingReminderForType(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
         * @summary Insert or Update a static data attached to a recipient
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptUpsertStaticDataRequest} usercryptUpsertStaticDataRequest Patch Condition request
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usercryptUpsertStaticData(params, options) {
            return localVarFp
                .usercryptUpsertStaticData(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Copies all the data - condition, checkin_entry, static_data, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | usercrypt | usercrypt | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {RbcRecipientCopyRequest} [rbcRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient(params, options) {
            return localVarFp
                .v1CopyDataToNewRecipient(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Copies all the data - condition, checkin_entry, static_data, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | usercrypt | usercrypt | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {UsercryptRecipientCopyRequest} [usercryptRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CopyDataToNewRecipient_1(params, options) {
            return localVarFp
                .v1CopyDataToNewRecipient_1(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.UsercryptApiFactory = UsercryptApiFactory;
/**
 * UsercryptApi - object-oriented interface
 * @export
 * @class UsercryptApi
 * @extends {BaseAPI}
 */
class UsercryptApi extends base_1.BaseAPI {
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/checkin/entries`
     * Add a new checkin entries |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
     * @summary add checkin entries
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
     * @param {UsercryptAddCheckinEntriesRequest} [usercryptAddCheckinEntriesRequest] The checkin data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptAddCheckinEntries(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptAddCheckinEntries(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries`
     * Add a new checkin entry |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
     * @summary add checkin entry
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} checkinTypeKey Checkin Type Key
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {UsercryptAddCheckinEntryRequest} [usercryptAddCheckinEntryRequest] The checkin data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptAddCheckinEntry(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptAddCheckinEntry(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`
     * Add checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
     * @summary Adds a reminder for the checkin type
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} checkinTypeKey Checkin Type Key
     * @param {string} userId User ID, Use \&quot;current\&quot;
     * @param {UsercryptCheckinReminderRequest} [usercryptCheckinReminderRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptAddSettingReminderForType(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptAddSettingReminderForType(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/conditions`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
     * @summary Post or create a condition attached to a recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {UsercryptCreateConditionRequest} usercryptCreateConditionRequest Patch Circle request
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptCreateCondition(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptCreateCondition(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/usercrypt/recipients/{recipient_id}/conditions`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
     * @summary Post or create a conditions attached to a recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {UsercryptCreateConditionsRequest} usercryptCreateConditionsRequest Create Conditions Request
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptCreateConditionsV2(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptCreateConditionsV2(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}`
     * Soft delete all recipient checkin data |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
     * @summary delete recipient data
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptDeleteAllRecipientData(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptDeleteAllRecipientData(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries/{checkin_entry_id}`
     * Delete an individual checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
     * @summary Delete checkin entry
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} checkinTypeKey Checkin Type Key
     * @param {number} checkinEntryId Checkin Entry Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptDeleteCheckinEntryById(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptDeleteCheckinEntryById(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/conditions/{condition_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | d |
     * @summary Delete a condition attached to a recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} conditionId Condition ID
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptDeleteCondition(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptDeleteCondition(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/conditions`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | d |
     * @summary Delete conditions attached to a recipient. If no condition IDs are provided, all conditions are deleted.
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<number>} id Condition IDs
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptDeleteConditions(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptDeleteConditions(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`
     * Deletes a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
     * @summary Deletes a reminder for the checkin type
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} checkinTypeKey Checkin Type Key
     * @param {string} userId User ID, Use \&quot;current\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptDeleteReminderForType(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptDeleteReminderForType(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders`
     * Deletes a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
     * @summary Deletes a reminder for the checkin type
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} userId User ID, Use \&quot;current\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptDeleteSettingReminder(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptDeleteSettingReminder(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/usercrypt/expunge`
     * Expunge all recipient checkin data permanently. |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|e|
     * @summary expunge recipient data
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptExpungeAllRecipientData(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptExpungeAllRecipientData(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/conditions`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
     * @summary Gets all conditions for the recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetAllConditions(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetAllConditions(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/checkin/entries/quota`
     * Get the number of entries given for a recipient today and what the max allowed is |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
     * @summary Get Recipient Daily Quota
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetCheckinDailyQuota(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetCheckinDailyQuota(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries`
     * get checkin entries for recipient |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
     * @summary get checkin entries
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} checkinTypeKey Checkin Type Key
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [start] Start date of search
     * @param {string} [end] End date of search
     * @param {number} [offset] The offset of results to return
     * @param {number} [limit] The limit of number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetCheckinEntriesByType(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetCheckinEntriesByType(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries/{checkin_entry_id}`
     * Get a single checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
     * @summary Get Checkin Entry By Id
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} checkinTypeKey Checkin Type Key
     * @param {number} checkinEntryId Checkin Entry Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetCheckinEntryById(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetCheckinEntryById(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/checkin/summary`
     * Gets the latest entries of each checkin type |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
     * @summary get latest checkin entries
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {boolean} [withEntry] Only with atleast one checkin entry
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
     * @param {'all' | 'bookmarked' | 'notBookmarked'} [bookmarks] Bookmark filter&lt;br /&gt; * **all** - This is the default, return all summaries regardless if they\&#39;re bookmarked or not&lt;br /&gt; * **bookmarked** - Only return summaries that are bookmarked&lt;br /&gt; * **notBookmarked** - Only return summaries that are NOT bookmarked. In other words, exclude bookmarks &lt;br /&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetCheckinLatestEntries(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetCheckinLatestEntries(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/checkin/entries`
     * Returns all recipient checkin entries |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
     * @summary all recipient checkin entries
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {string} [checkinTypeKey] Return only provided checkin types. Multiple keys supported in form ?checkin_type_key&#x3D;one&amp;checkin_type_key&#x3D;two (example) where the API will return for both one and two
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetCheckinRecipientEntries(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetCheckinRecipientEntries(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/checkin/types`
     * returns checkin type meta data |Feature|Dataclass|Permission| |-------|---------|----------|
     * @summary Checkin types
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetCheckinTypes(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetCheckinTypes(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/conditions/{condition_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
     * @summary Gets a condition attached to a recipient by ID
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} conditionId Condition ID
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetConditionById(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetConditionById(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/settings/reminders`
     * Get all recipient reminders |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
     * @summary get recipient reminders
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetSettingAllRecipientReminders(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetSettingAllRecipientReminders(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`
     * Get reminder of checkin type if it exists |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|r|
     * @summary Get user checkin reminder for this checkin type
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} checkinTypeKey Checkin Type Key
     * @param {string} userId User ID, Use \&quot;current\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetSettingReminderByType(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetSettingReminderByType(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/static`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | r |
     * @summary Gets statis information attached to a recipient by ID
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetStaticData(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetStaticData(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/conditions`
     * returns supported conditions in backend config |Feature|Dataclass|Permission| |-------|---------|----------|
     * @summary Get Supported Conditions
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptGetSupportedConditions(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptGetSupportedConditions(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/conditions/{condition_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | u |
     * @summary Patch or update a condition attached to a recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} conditionId Condition ID
     * @param {UsercryptPatchConditionRequest} usercryptPatchConditionRequest Patch Condition request
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptPatchCondition(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptPatchCondition(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/settings/bookmarks/{checkin_type_key}`
     * Bookmarks a checkin type |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|c|
     * @summary bookmark a checkin type
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} checkinTypeKey Checkin Type Key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptPutSettingsBookmarkType(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptPutSettingsBookmarkType(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/settings/bookmarks/{checkin_type_key}`
     * Removes a checkin type key bookmark |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|d|
     * @summary unbookmark a checkin type key
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} checkinTypeKey Checkin Type Key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptRemoveBookmarkType(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptRemoveBookmarkType(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/checkin/types/{checkin_type_key}/entries/{checkin_entry_id}`
     * Update an existing checkin entry by id |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|u|
     * @summary Update checkin entry
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} checkinTypeKey Checkin Type Key
     * @param {number} checkinEntryId Checkin Entry Id
     * @param {UsercryptUpdateCheckinEntryRequest} [usercryptUpdateCheckinEntryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptUpdateCheckinEntryById(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptUpdateCheckinEntryById(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/settings/users/{user_id}/reminders/{checkin_type_key}`
     * Update a checkin reminder |Feature|Dataclass|Permission| |-------|---------|----------| |usercrypt|usercrypt|u|
     * @summary Updates a reminder for the checkin type
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} checkinTypeKey Checkin Type Key
     * @param {string} userId User ID, Use \&quot;current\&quot;
     * @param {UsercryptCheckinReminderRequest} [usercryptCheckinReminderRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptUpdateSettingReminderForType(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptUpdateSettingReminderForType(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/static`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | usercrypt | usercrypt | c |
     * @summary Insert or Update a static data attached to a recipient
     * @param {number} recipientId A ID of the recipient self circle
     * @param {UsercryptUpsertStaticDataRequest} usercryptUpsertStaticDataRequest Patch Condition request
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    usercryptUpsertStaticData(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .usercryptUpsertStaticData(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/recommendations/recipients/{recipient_id}/copy`
     * Copies all the data - condition, checkin_entry, static_data, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.   |Feature|Dataclass|Permission|   |-------|---------|----------|   | usercrypt | usercrypt | c |
     * @summary v1 Copy Data To New Recipient
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {RbcRecipientCopyRequest} [rbcRecipientCopyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    v1CopyDataToNewRecipient(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .v1CopyDataToNewRecipient(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/usercrypt/recipients/{recipient_id}/copy`
     * Copies all the data - condition, checkin_entry, static_data, settings - that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | usercrypt | usercrypt | c |
     * @summary v1 Copy Data To New Recipient
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {UsercryptRecipientCopyRequest} [usercryptRecipientCopyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsercryptApi
     */
    v1CopyDataToNewRecipient_1(params, options) {
        return (0, exports.UsercryptApiFp)(this.configuration)
            .v1CopyDataToNewRecipient_1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.UsercryptApi = UsercryptApi;
//# sourceMappingURL=usercrypt-api.js.map